import { render, staticRenderFns } from "./ActualizacionDialog.vue?vue&type=template&id=32163950"
import script from "./ActualizacionDialog.vue?vue&type=script&lang=js"
export * from "./ActualizacionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports